/**
 * Stacking order for the AddFieldPickerSlideout drawer.
 *
 * - `FullscreenTakeover` (the page behind the slideout) sits at `1040`.
 * - `SlideoutDrawerV2` defaults to `1030/1040`, which leaves the
 *   takeover's header bar + footer buttons bleeding through the
 *   transparent overlay. Bumping the drawer above the takeover keeps
 *   the picker visually layered on top.
 *
 * Mirrors `QuerySettingsPanel/zIndex.ts` — same takeover, same fix.
 */
export const Z_INDEX = {
  drawer: 1050,
} as const;
